import { useCallback } from 'react';
import { useUserLevelSettings } from '../../context/UserLevelSettingsContext';
export const useUserEntitlements = () => {
    const { currentUser } = useUserLevelSettings();
    const hasUserEntitlement = useCallback((entitlement, entityId) => {
        if (!currentUser?.entitlements.length) {
            return false;
        }
        return currentUser.entitlements.some((ent) => ent.type === entitlement && ent.entityId === entityId);
    }, [currentUser]);
    return { hasUserEntitlement };
};
